<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<userMsg
				type="2"
				:otherId="otherId"
				ref="childUser"
				@botHide="botHide"
				@botShow="botShow"
			></userMsg>
			<div v-show="isTabbar" class="bottom_btn">
				<van-button
					type="info"
					block
					@click="onSubmit"
					color="#4f56fe"
				>
					保存
				</van-button><br />
				<van-button
					v-if="isEdit"
					plain
					type="info"
					block
					@click="onDelete"
					color="#4f56fe"
				>
					删除
				</van-button>
			</div>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import { otherTestList } from "@/api/record/index";
import { otherDelete } from "@/api/other/index";
import userMsg from '@/components/userMsg'
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		userMsg,
	},
	data() {
		return {
			isEdit: false,  //是否为编辑
			otherId: null,  //用户id
			isTabbar: false, //判断页面的fixed内容是展示还是隐藏
		}
	},
	created() {
		let that = this;
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
		if(that.$route.query.type == 1) {
			that.isEdit = false;
		}else if(that.$route.query.type == 2) {
			that.isEdit = true;
			that.otherId = that.$route.query.value;
		}else {
			window.history.go(-1);
		}
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			setTimeout(() => {
				that.isTabbar = true;
			}, 30);
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		botHide() {
			this.isTabbar = false;
		},
		botShow() {
			this.isTabbar = true;
		},
		//返回列表
		goList() {
			let that = this;
			window.history.go(-1);
		},
		//点击保存
		onSubmit() {
			let that = this;
			that.$refs.childUser.onSubmit();
		},
		//点击删除
		onDelete() {
			let that = this;
			//请求列表
			otherTestList({
				id: that.otherId,
				page: 1,
				page_size: 10,
			}).then(res => {
				let str = '';
				if(res.data.data.length > 0) {
					//有账号
					str = '删除后将无法查看该成员检测记录，确定删除？';
				}else {
					//无账号
					str = '确定删除该人员吗？';
				}
				that.$dialog.confirm({
					title: '提示',
					message: str,
					confirmButtonText: '取消',
					cancelButtonText: '确定',
					confirmButtonColor: '#333333',
				}).then(() => {
					//取消
				}).catch(() => {
					//确定
					otherDelete({id: that.otherId}).then(res => {
						that.$toast('删除成功');
						setTimeout(() => {
							that.goList();
						}, 500);
					});
				});
			});
		},
	},
	beforeDestroy() {
		//
	}
}
</script>
</script>

<style scoped>

.van-button{
	height: 1.2rem;
}
.bottom_btn{
	/* position: fixed; */
	margin-top: 4rem;
	width: 100%;
	left: 0;
	padding: 1.2rem 1rem;
	bottom: 0;
}
</style>
